import React from 'react';

import type { IconProps, SVGPaths } from '@coursera/cds-common';
import { createSvgIcon } from '@coursera/cds-common';

/**
 * Allowed icon sizes for createSizedSvgIcon
 */
type AllowedIconSize = '18px';

/**
 * Private module reserved for @coursera/cds-core package.
 */
const createSizedSvgIcon = (
  displayName: string,
  paths: { large: SVGPaths },
  size: AllowedIconSize,
  shouldFlipForRTL?: boolean
): React.ComponentType<IconProps> => {
  const Icon = createSvgIcon(
    displayName,
    {
      ltr: {
        ...paths,
      },
    },
    shouldFlipForRTL
  );

  return React.forwardRef(function SizedIcon(
    props: IconProps,
    ref: React.Ref<SVGSVGElement>
  ) {
    return <Icon {...props} ref={ref} height={size} width={size} />;
  });
};

export default createSizedSvgIcon;
